export const StatCard = ({ label, value, icon: Icon, accent = false, sub, testId }) => (
  <div data-testid={testId} className="flex items-start justify-between border border-gray-200 bg-white p-5">
    <div>
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">{label}</p>
      <p className={`mt-2 font-heading text-2xl font-semibold ${accent ? "text-[#D4AF37]" : "text-[#0B1F3A]"}`}>{value}</p>
      {sub && <p className="mt-1 text-xs text-gray-400">{sub}</p>}
    </div>
    {Icon && (
      <div className={`flex h-10 w-10 shrink-0 items-center justify-center ${accent ? "bg-[#D4AF37]/10 text-[#D4AF37]" : "bg-[#0B1F3A]/5 text-[#0B1F3A]"}`}>
        <Icon size={20} strokeWidth={1.5} />
      </div>
    )}
  </div>
);
